module.exports = __webpack_public_path__ + "img/language_pairs.4d313eda.png";